import { css } from "@emotion/core"

export const labelStyle = theme => css`
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 0.39px;
  color: ${theme.colors.purples.normal};
  margin-bottom: 0.4rem;
`
